export default "__VITE_ASSET__4gghyNxE__"